angular
    .module('tradersyard')
    .run([
        'graph-api-client',
        'graph-meeting-factory',
        function ($api, $factory) {
            $api.factory.meeting = $factory;
        },
    ])
    .factory('graph-meeting-factory', [
        'graph-api-client',
        'graph-message-factory',
        function (client, messages) {
            return {
                entry: function (entry, id) {
                    return new meetings(entry, id);
                },
                friend: function (id, options) {
                    return client.get([id, 'meeting'], options);
                },
                getMeetingById,
                inviteFriendToMeeting,
                getMeetingJoinUrlForRoomName,
                getVideoConferenceConnectOptions,
            };

            /**
             * Invite a friend to a web meeting held on Choop.Chat
             * @param {string} meetingRoomName
             * @param {number} friendId
             */
            function inviteFriendToMeeting(meetingRoomName, friendId) {
                return client.post('meeting/web/invite', {
                    roomId: meetingRoomName,
                    toUserId: friendId,
                });
            }

            function getMeetingById(meetingId) {
                return client.get(['meeting', meetingId]);
            }

            /**
             * @param roomName
             * @returns {angular.IPromise<string>}
             */
            function getMeetingJoinUrlForRoomName(roomName) {
                return client
                    .post('meeting/web-join-url', {
                        room_name: roomName,
                        external_api: 'iframe',
                    })
                    .then(function (response) {
                        console.log('getMeetingJoinUrlForRoomName', response.data);

                        return response.data.data.join_url;
                    });
            }

            /**
             * Get connection options to Choop.Chat for specified meeting ID.
             * API should return parameters usable with JitsiMeetExternalAPI.
             *
             * @return {Promise<ApiVideoConferenceConnectOptions>}
             */
            function getVideoConferenceConnectOptions(meetingId) {
                return client.get(`meeting/${meetingId}/video-conference-connect`).then(function (response) {
                    return response.data.data;
                });
            }

            function meetings(entry, id) {
                if (entry === 'user') entry = undefined;

                this.query = function (options) {
                    return client.get([entry, id, 'meetings'], options);
                };

                this.read = function (meeting_id, options) {
                    return client.get(['meeting', meeting_id], options);
                };

                this.unread = function (options) {
                    return client.get(['meeting', 'unread'], options);
                };

                this.messages = function (meeting_id) {
                    return new messages.entry(meeting_id);
                };
            }
        },
    ]);
